<template>
  <div>
    <v-card :key="DO.id" class="mb-2" v-for="DO in results">
      <v-card-title>
        <v-layout row>
          <span class="headline mb-0"
            >D/O #{{ DO.doNo }}-{{ DO.branchCode }}</span
          >
          <span class="ml-2 pt-2">{{ DO.status }}</span>
          <v-spacer />
          <span>{{ DO.transportModeCode }}</span>
          <span class="ml-4">{{ DO.incotermCode }}</span>
          <span class="ml-4"
            >{{ DO.loadingPortCode }}:{{ DO.loadingPortName }}</span
          >
          <span class="ml-2">→</span>
          <span class="ml-2"
            >{{ DO.dischargePortCode }}:{{ DO.dischargePortName }}</span
          >
          <v-btn
            @click="releaseDo(DO)"
            v-if="DO.status === 'DO確定済'"
            v-permit.SHARP_PSCD_DO_CANCEL
            >DO解除</v-btn
          >
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="DO.packages"
        :loading="loading"
        hide-actions
        item-key="id"
      >
        <template slot="items" slot-scope="props">
          <td width="150">{{ DO.blNo }}</td>
          <td width="150">{{ props.item.invoiceNo }}</td>
          <td :style="diffStyle('poNo', props.item)" width="150">
            {{ props.item.poNo }}
          </td>
          <td width="200">
            {{ props.item.productCode }}:{{ props.item.productName }}
          </td>
          <td width="200">{{ props.item.skuCode }}</td>
          <td width="100">{{ props.item.paid ? '有償' : '無償' }}</td>
          <td width="100">
            {{ props.item.cartonStartNo }}-{{ props.item.cartonEndNo }}
          </td>
          <td width="100">{{ props.item.perCartonQty }}</td>
          <td :style="diffStyle('qty', props.item)" width="100">
            {{ props.item.totalQty }}
          </td>
          <td width="100">{{ props.item.currencyCode }}</td>
          <td :style="diffStyle('unitPrice', props.item)" width="100">
            {{ props.item.unitPrice }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ['id'],
  data() {
    return {
      form: {},
      status: { NORMAL: '', CONFLICT: 'PO变更', CANCEL: 'PO取消' },
      headers: [
        { text: 'B/L NO', value: 'blNo', sortable: false },
        { text: 'INV NO', value: 'invNo', sortable: false },
        { text: 'P/O NO', value: 'poNo', sortable: false },
        { text: '品種', value: 'productName', sortable: false },
        { text: '品番', value: 'skuCode', sortable: false },
        { text: '有償/無償', value: 'paid', sortable: false },
        { text: 'Carton', value: 'carton', sortable: false },
        { text: '入り数', value: 'perCartonQty', sortable: false },
        { text: '数量', value: 'totalQty', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: '単価', value: 'unitPrice', sortable: false },
      ],
      results: [],
      loading: false,
      conflictType: 'UNKNOWN',
      conflictFields: [],
    }
  },
  methods: {
    releaseDo(DO) {
      this.$http
        .put(`delivery-orders/${DO.id}/cancel-confirm-apply`, {
          cancelReason: 'DO取消',
        })
        .then(() => {
          this.$message('', 'DO解除承認待ち')
          this.load()
          this.show = false
        })
    },
    diffStyle(prop, item) {
      if (this.poNo === item.poNo && this.conflictFields.indexOf(prop) !== -1)
        return 'color: red; font-weight: bold; font-size: 16px'
      return ''
    },
    highlight(type, fields) {
      this.conflictType = type || 'UNKNOWN'
      this.conflictFields = fields || []
    },
    load() {
      this.loading = true
      this.$http.get(`/delivery-orders/${this.id}/conflict-do`).then((res) => {
        this.results = [...res.data]
        // this.results.forEach(DO =>
        //   DO.packages.sort((a, b) => (b.poNo || '').localeCompare(a.poNo || ''))
        // )
        this.loading = false
      })
    },
  },
  mounted() {
    this.load()
  },
  computed: {},
}
</script>
